import { AppLink } from '@common/components/Link/AppLink';
import { MediaItemLabel } from '@common/components/MediaItemLabel';
import { Clip } from '@features/Clip';
import { createAssetDetailsPagePath } from '@router';

interface ClipTitleCellProps {
    clip: Clip;
}

export const ClipTitleCell = ({ clip }: ClipTitleCellProps) => {
    if (!clip) return null;

    const { id, clipName, hasProxy } = clip;
    const detailPath = createAssetDetailsPagePath(id);

    return (
        <AppLink
            to={detailPath}
            style={{ display: 'block', width: '100%', textDecoration: 'none' }}
        >
            <MediaItemLabel name={clipName} hasProxy={hasProxy} />
        </AppLink>
    );
};
